import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.isAuthenticated$.pipe(
        take(1),
        map(isAuthenticated => {
            if (!isAuthenticated) {
                router.navigate(['/']);
                return false;
            }

            const role = (authService.getRole() || '').toUpperCase();
            const isAssistantRoute = state.url.startsWith('/assistant-cases');

            // ASSISTANT can only access /assistant-cases
            if (role === 'ASSISTANT' && !isAssistantRoute) {
                router.navigate(['/assistant-cases']);
                return false;
            }

            // Non-ASSISTANT users cannot access /assistant-cases
            if (role !== 'ASSISTANT' && isAssistantRoute) {
                router.navigate(['/dashboard']);
                return false;
            }

            return true;
        })
    );
};
